import React from "react";
import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { useI18n } from "../i18n";

const ARIOVIS_LOGO_WHITE = "https://brand.ariovis.fr/logos/Logotype_Secondary_WHITE.svg";
const ARIOVIS_HOME = "https://ariovis.fr";
const ARIOVIS_PRODUCTS = "https://ariovis.fr/produits";

export default function Footer() {
    const { t, lang } = useI18n();
    return (
        <footer className="mt-24 bg-slate-950 text-slate-300" data-testid="site-footer">
            <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 py-14 sm:px-6 md:grid-cols-3 lg:px-8">
                <div>
                    <a href={ARIOVIS_HOME} aria-label="Ariovis">
                        <img src={ARIOVIS_LOGO_WHITE} alt="Ariovis" className="h-8 w-auto" loading="lazy" />
                    </a>
                    <p className="mt-4 max-w-xs text-sm text-slate-400">
                        {lang === "fr"
                            ? "Pure-player européen de l'IAM, IAG, Access Management, autorisation et PAM."
                            : "European IAM, IAG, Access Management, authorization and PAM pure-player."}
                    </p>
                </div>

                <div>
                    <div className="text-xs font-semibold uppercase tracking-[0.24em] text-slate-500">
                        {lang === "fr" ? "Ce mini-produit" : "This mini-product"}
                    </div>
                    <ul className="mt-4 space-y-2 text-sm">
                        <li>
                            <Link to={`/${lang}#method`} className="hover:text-white" data-testid="footer-method">
                                {t("nav.method")}
                            </Link>
                        </li>
                        <li>
                            <Link to={`/${lang}#faq`} className="hover:text-white" data-testid="footer-faq">
                                {t("nav.faq")}
                            </Link>
                        </li>
                        <li>
                            <Link to={`/${lang}/wizard`} className="hover:text-white" data-testid="footer-start">
                                {t("nav.start")}
                            </Link>
                        </li>
                    </ul>
                </div>

                <div>
                    <div className="text-xs font-semibold uppercase tracking-[0.24em] text-slate-500">Ariovis</div>
                    <ul className="mt-4 space-y-2 text-sm">
                        <li>
                            <a
                                href={ARIOVIS_PRODUCTS}
                                className="inline-flex items-center gap-1 hover:text-white"
                                data-testid="footer-products"
                            >
                                {lang === "fr" ? "Tous les produits Ariovis" : "All Ariovis products"}
                                <ExternalLink className="h-3 w-3" aria-hidden />
                            </a>
                        </li>
                        <li>
                            <a
                                href={ARIOVIS_HOME}
                                className="inline-flex items-center gap-1 hover:text-white"
                                data-testid="footer-home"
                            >
                                ariovis.fr
                                <ExternalLink className="h-3 w-3" aria-hidden />
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://brand.ariovis.fr"
                                className="inline-flex items-center gap-1 hover:text-white"
                                target="_blank"
                                rel="noreferrer"
                            >
                                {lang === "fr" ? "Charte de marque" : "Brand center"}
                                <ExternalLink className="h-3 w-3" aria-hidden />
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-slate-900 py-6">
                <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-2 px-4 text-xs text-slate-500 sm:flex-row sm:items-center sm:px-6 lg:px-8">
                    <div>{t("footer.legal")}</div>
                    <div>{t("brand.company")}</div>
                </div>
            </div>
        </footer>
    );
}
